export const MAINTENANCE_PRIORITY = {
  LOW: 100,
  MEDIUM: 200,
  HIGH: 300,
  CRITICAL: 400,
} as const;

export type MaintenancePriorityCode =
  (typeof MAINTENANCE_PRIORITY)[keyof typeof MAINTENANCE_PRIORITY];

export const MAINTENANCE_PRIORITY_LABEL_KEYS: Record<MaintenancePriorityCode, string> = {
  100: "createPmOrder.priorityLow",
  200: "createPmOrder.priorityMedium",
  300: "createPmOrder.priorityHigh",
  400: "createPmOrder.priorityCritical",
};
